export enum Tags {
  DecimalWrapped = "saber-decimal-wrapped",
}
